import React, { Fragment, useState } from "react"
import compose from "ramda/src/compose"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import Container from "shared/components/DefaultContainer"
import DefaultTitle from "shared/components/DefaultTitle"
import Typograph from "components/Typograph"
import BenefitCard from "./components/BenefitCard"
import ProcessCard from "./components/ProcessCard"
import Button from "shared/components/Button/Button"
import HeroVideo from "./components/HeroVideo"
import RequestForm from "./components/RequestForm"

import styles from "./styles.css"

import ShareImg from "../../assets/png/share-energy.png"

function ShareEnergy({ customer }) {
  const [isOpenForm, setIsOpenForm] = useState(false)

  const handleClickLearnMore = () => {
    window.open(
      "https://loja.algar.com.br/empresas/compartilheenergia/?utm_source=algar&utm_medium=portal-b2b&utm_campaign=algar_portalb2b_compartilheenergia",
      "_blank"
    )
  }

  return (
    <Fragment>
      <DefaultTitle>Compartilhe energia</DefaultTitle>
      <Container>
        <Typograph
          htmlTag="h2"
          size="large"
          weight="semi_bold"
          color="outer_space"
          classNames={styles.description}
        >
          Economize até 24% na sua tarifa de energia e invista mais no
          crescimento do seu negócio.
        </Typograph>
        <img src={ShareImg} alt="Sem instalação - 100% digital" />

        <BenefitCard />
        <ProcessCard />
        <HeroVideo />

        <div className={styles.buttons}>
          <Button
            buttonStyle="secondary"
            onClick={() => handleClickLearnMore()}
          >
            Saber mais
          </Button>

          <Button buttonStyle="primary" onClick={() => setIsOpenForm(true)}>
            Aderir agora
          </Button>
        </div>
        <RequestForm
          isOpenForm={isOpenForm}
          onClose={() => setIsOpenForm(false)}
          customer={customer}
        />
      </Container>
    </Fragment>
  )
}

ShareEnergy.propTypes = {
  customer: PropTypes.object
}
const mapStateToProps = ({ customer }) => {
  return {
    customer: customer.data
  }
}
const enhance = compose(connect(mapStateToProps, {}))

export default enhance(ShareEnergy)



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/index.js